import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

/*----------- duplicita s trainings------------*/

export class EmployeesApiService {

  constructor(private http: HttpClient) { }
    /*** Employee*/
    public getEmployees(): Observable<any> {
        const params = new HttpParams();
        // params = params.append('filter', JSON.stringify({}));
        return this.http.get('/api/employee', {params: params});
    }

    public createEmployee(data): Observable<any> {
        return this.http.post('/api/employee', data);
    }

    public getEmployee(id): Observable<any> {
        return this.http.get('/api/employee/' + id);
    }

    public updateEmployee(id, data): Observable<any> {
        return this.http.put('/api/employee/' + id, data);
    }

    public removeEmployee(id): Observable<any>{
        return this.http.delete('/api/employee/' + id);
    }
}
